import {DestroyRef, inject, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {filter, map, tap} from 'rxjs/operators';

import {AccountClosedEvent, IAccountClosedPayload} from '@shared/application/events/account/account-closed.event';
import {ACCOUNT_STORE} from '@core/entities/account/domain/tokens/account-store.token';
import {EventBusPort} from "@platform/event-bus/domain/ports/event-bus.port";
import {Account} from "@core/entities/account/domain/model/account.model";
import {PaymentStatus, PaymentStatusChangedEvent} from "@platform/event-bus/domain/events/payment/payment-status-changed.event";

@Injectable({providedIn: 'root'})
export class PlatformOnCartOrderSettledSubscriber {
  private readonly destroyRef = inject(DestroyRef);
  private readonly eventBus = inject(EventBusPort);
  private readonly legacyAccountStore = inject(ACCOUNT_STORE);

  constructor() {
    this.eventBus
      .ofType(PaymentStatusChangedEvent)
      .pipe(
        filter(({payload}) => payload.status === PaymentStatus.SUCCESS),
        map(() => this.legacyAccountStore.getSelectedAccount()),
        filter((account): account is Account => !!account),
        map(
          (account): IAccountClosedPayload => ({
            accountId: account.id,
            trackId: account.trackId ?? '',
          }),
        ),
        tap(payload => this.eventBus.publish(new AccountClosedEvent(payload))),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}
